import { DealListApiResponse } from '../types'

class DealListService {
  private baseUrl = '/api'

  /**
   * Fetch ISO deals with submissions
   */
  async getISODeals(): Promise<DealListApiResponse> {
    try {
      const response = await fetch(`${this.baseUrl}/iso-deals`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })

      if (!response.ok) {
        const errorData = await response.json()
        throw new Error(errorData.message || 'Failed to fetch ISO deals')
      }

      return await response.json()
    } catch (error) {
      console.error('Error fetching ISO deals:', error)
      throw error
    }
  }

  /**
   * Refresh ISO deals data
   */
  async refreshISODeals(): Promise<DealListApiResponse> {
    try {
      const response = await fetch(`${this.baseUrl}/iso-deals/refresh`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })

      if (!response.ok) {
        const errorData = await response.json()
        throw new Error(errorData.message || 'Failed to refresh ISO deals')
      }

      return await response.json()
    } catch (error) {
      console.error('Error refreshing ISO deals:', error)
      throw error
    }
  }
}

export const dealListService = new DealListService()
